import CHAT from '../Chat/locales/en/chat.json';
import SPREADSHEET_IMPORT from '../SpreadSheetImport/locales/en/spreadsheetImport.json';

// Map resources
export const resources = {
  chat: CHAT,
  spreadsheet_import: SPREADSHEET_IMPORT,
} as const;

export default resources;
